module.exports = __webpack_public_path__ + "assets/img/kt-renewed-2.52f77134.png";